import url from '@/creditflowresearch/infrastructure/url';

interface IGetArticlesMetaSchemaProps {
  pathname: string,
  products?: string,
  regions?: string,
  markets?: string,
  segments?: string,
}

const getArticlesMetaSchema = ({
  pathname,
  products = '',
  regions = '',
  markets = '',
  segments = '',
}: IGetArticlesMetaSchemaProps) => {
  const fullContext = [markets, regions, segments, products].filter(Boolean).join(' ');

  const titlePrefix = fullContext ? `${ fullContext } ` : '';
  const title = `${ titlePrefix } Commentary, Deal Flow & Market Color`;
  const description = fullContext
    ? `Browse and filter the latest commentary, deal flow, and market color articles for ${ fullContext }.`
    : 'Browse and filter the latest commentary, deal flow, and market color articles.';

  const keywords = [
    products,
    regions,
    markets,
    segments,
    'commentary',
    'deal flow',
    'fixed income',
  ].filter(Boolean);

  return {
    '@context': 'https://schema.org',
    '@type': 'SearchResultsPage',
    url: url.getUrl(pathname),
    name: title,
    description,
    keywords,
    isAccessibleForFree: false,
  };
};

export default getArticlesMetaSchema;
